import NotRelevantModal from "./NotRelevantModal";

export default NotRelevantModal;
